// import Swiper from 'swiper/core/core';
// import Navigation from 'swiper/modules/navigation/navigation';
// import Pagination from 'swiper/modules/pagination/pagination';
// import EffectFade from 'swiper/modules/effect-fade/effect-fade';
// import EffectCoverflow from "swiper/modules/effect-coverflow/effect-coverflow";
// import EffectCreative from "swiper/modules/effect-creative/effect-creative";
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, EffectCoverflow, EffectCreative } from 'swiper/modules';
import { SWIPER_CONFIG } from '../config/swiper';

// Add modules
Swiper.use([
    Navigation,
    Pagination,
    EffectFade,
    EffectCoverflow,
    EffectCreative,
]);

// Instantiate
const swiperElements = Array.from(document.querySelectorAll('.swiper'));

const initSwiper = (element) => {
    const isTimeline = element.classList.contains('swiper-timeline');
    const swiperInstance =  new Swiper(element, {
        ...SWIPER_CONFIG,

        // Vanilla JS config
        ...{
            navigation: {
                nextEl: `#${element.id}-next`,
                prevEl: `#${element.id}-prev`
            },
            pagination: {
                el: `#${element.id}-pagination`,
                clickable: true
            },
        },
        ...(
            JSON.parse(element.dataset?.config || '{}')
        ),
        // Specific configs
        ...(
            element.classList.contains('carousel--hero') ? {
                slidesPerView: '1.2',
                spaceBetween: 2,
                grabCursor: true,
                breakpoints: {
                    992: {
                        slidesPerView: '2.2',
                    },
                    1280: {
                        slidesPerView: '3',
                    }
                },
            } : {}
        ),
    });

    if (isTimeline) {

        document.querySelector(`#${element.id}-timeline-button-prev`).addEventListener('click', function() {
            swiperInstance.slidePrev();
        });

        document.querySelector(`#${element.id}-timeline-button-next`).addEventListener('click', function() {
            swiperInstance.slideNext();
        });

        document.querySelectorAll(`#timeline-${element.id} .timeline-item`).forEach(function(item, index) {
            item.addEventListener('click', function() {
                swiperInstance.slideToLoop(index);
            });
        });

        swiperInstance.on('slideChange', function() {
            updateActiveClass(swiperInstance.realIndex, element.id);
        });

        window.addEventListener('resize', function() {
            updateActiveClass(swiperInstance.realIndex, element.id);
        });

        updateActiveClass(swiperInstance.realIndex, element.id);
    }

    return swiperInstance;
}


swiperElements.forEach((element) => {
    initSwiper(element);
});

function updateActiveClass(index, elementId) {
    const timelineItems = document.querySelectorAll(`#timeline-${elementId} .timeline-item`);
    timelineItems.forEach(function(item, i) {
        if (i === index) {
            item.classList.add('active');
            scrollToElement(item);
        } else {
            item.classList.remove('active');
        }
    });
}

/*
 * Custom scroll function to bring the item into view
 */
function scrollToElement(element) {
    const parent = element.parentElement;
    const parentRect = parent.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const offset = elementRect.left - parentRect.left + parent.scrollLeft;

    parent.scrollTo({
        left: offset,
        behavior: 'smooth'
    });
}
